import React from 'react';
import { Box } from '@mui/material';

export interface ListPageMainProps {
  children: React.ReactNode;
  /** Multiplicador de `theme.spacing` entre bloques (toolbar, filtros, tabla). Por defecto 3. */
  sectionGap?: number;
}

/**
 * Columna principal (toolbar + filtros + tabla + paginación) con espaciado uniforme.
 */
const ListPageMain: React.FC<ListPageMainProps> = ({ children, sectionGap = 3 }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: sectionGap,
      height: '100%',
    }}
  >
    {children}
  </Box>
);

export default ListPageMain;
